export default "__VITE_ASSET__8bc42c12__"